<mbs-modal
  class="mbs-rd-enable"
  [title]="'shared:computers.superAdmin.title' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="mbsPopupType.danger"
      [icon]="true">
      {{ 'shared:computers.superAdmin.message' | i18next }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button (click)="baseModal.close()">{{ 'shared:buttons.close' | i18next }}</mbs-button>
  </ng-container>
</mbs-modal>
